export const GET_MY_DEMOS_START = 'GET_MY_DEMOS_START'
export const RESET_DEMOS = 'RESET_DEMOS'
export const GET_MY_DEMOS_SUCCESS = 'GET_MY_DEMOS_SUCCESS'
export const GET_MY_DEMOS_FAILURE = 'GET_MY_DEMOS_FAILURE'
